import SpinModel from "../../model/SpinModel";
import { ICondition } from "../State";

export class HasFreeSpinsCondition implements ICondition {
    public check(): boolean {
        return SpinModel.hasFreespins();
    }
}
